var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconVocabulary = function SvgIconVocabulary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    clipPath: "url(#icon-vocabulary_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 4.607c-.733-.933-1.864-1.867-4.666-1.935a.33.33 0 0 0-.334.33v8.064c0 .184.15.329.334.335 2.802.091 3.933 1.334 4.666 2.267m0-9.06c.733-.934 1.864-1.868 4.666-1.936a.325.325 0 0 1 .334.326v8.067a.34.34 0 0 1-.334.336c-2.802.091-3.933 1.334-4.666 2.267m0-9.06v9.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.823 4h1.51c.184 0 .333.15.333.333v8.693c0 .27-.318.449-.564.34a6.4 6.4 0 0 0-2.573-.524C9.57 12.842 8 14 8 14s-1.568-1.158-3.529-1.158a6.4 6.4 0 0 0-2.573.523c-.246.11-.564-.07-.564-.339V4.333c0-.184.15-.333.333-.333h1.51"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-vocabulary_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgIconVocabulary;